import { createFeatureSelector, createSelector } from '@ngrx/store'
import {
  CUSTOMER_PAYMENT_METHODS_FEATURE_KEY,
  CustomerPaymentMethodsState,
  customerPaymentMethodsAdapter,
} from './customer-payment-methods.reducer'

// Lookup the 'CustomerPaymentMethods' feature state managed by NgRx
export const selectCustomerPaymentMethodsState = createFeatureSelector<CustomerPaymentMethodsState>(
  CUSTOMER_PAYMENT_METHODS_FEATURE_KEY,
)

const { selectAll, selectEntities } = customerPaymentMethodsAdapter.getSelectors()

export const selectCustomerPaymentMethodsLoaded = createSelector(
  selectCustomerPaymentMethodsState,
  (state: CustomerPaymentMethodsState) => state.loaded,
)

export const selectCustomerPaymentMethodsError = createSelector(
  selectCustomerPaymentMethodsState,
  (state: CustomerPaymentMethodsState) => state.error,
)

export const selectAllCustomerPaymentMethods = createSelector(
  selectCustomerPaymentMethodsState,
  (state: CustomerPaymentMethodsState) => selectAll(state),
)

export const selectCustomerPaymentMethodsEntities = createSelector(
  selectCustomerPaymentMethodsState,
  (state: CustomerPaymentMethodsState) => selectEntities(state),
)
